import { z } from "zod";
import { optional } from "./appointments";
import { recordId } from "./contracts";
import { contractReadQuery } from "./daily-work";

const named = z.object({ id: recordId, name: z.string() });

export const taskTemplateListQuery = contractReadQuery.extend({
  service: optional(recordId.toLowerCase()),
});
export type TaskTemplateListQuery = z.infer<typeof taskTemplateListQuery>;

export const taskTemplate = z.object({ id: recordId, service: named, tasks: z.array(z.string()) });
export type TaskTemplate = z.infer<typeof taskTemplate>;

export const taskTemplateList = z.object({ items: z.array(taskTemplate) });
export type TaskTemplateList = z.infer<typeof taskTemplateList>;
